/**
 * Status badge for customization templates.
 * Draft = gray, Active = green. Uses color + text for accessibility.
 *
 * Plan: 117-personalization-admin-ui, Epic 01
 */

import { cn } from "@/lib/utils";

interface TemplateStatusBadgeProps {
  status: "Draft" | "Active";
  className?: string;
}

export function TemplateStatusBadge({ status, className }: TemplateStatusBadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium",
        status === "Active"
          ? "bg-green-50 text-green-700"
          : "bg-gray-100 text-gray-600",
        className,
      )}
    >
      <span
        className={cn(
          "h-1.5 w-1.5 rounded-full",
          status === "Active" ? "bg-green-500" : "bg-gray-400",
        )}
      />
      {status}
    </span>
  );
}
